<template>
  <div>
  	<Subpage/>
      <div class="page-content container">
        <main>          
			<h1 class="page-title">Czy wiecie, że...</h1>          
			<div class="breadcrumbs-area">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
						<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
							<a itemprop="item" href="http://kontur.it/" target="_self"><span itemprop="name">Strona gł&oacute;wna</span></a><span class="separator">/</span>
						</li>
						<li class="active">Czy wiecie, że...</li>
					</ol>
				</nav>
			</div>
			    <div class="page-list"> 
			        <article class="page-list-item page-list-item-with-thumbnail">
			            <div class="page-list-item-thumbnail">
			                <a class="bg-hover ico-link" href="http://kontur.it/czy-wiecie-ze/gliwicka-radiostacja" target="_self" title="Gliwicka Radiostacja">
			                    <img src="@/assets/img/radio.jpg" width="300" height="206" alt="Gliwicka Radiostacja" />
			                </a>
			            </div>       
			            <h3 class="page-list-item-title">
			                <a href="http://kontur.it/czy-wiecie-ze/gliwicka-radiostacja" target="_self" title="Gliwicka Radiostacja">Gliwicka Radiostacja</a>
			            </h3>
			            <div class="page-list-item-date">9 stycznia 2018</div>       
			            <div class="page-list-item-description">
			                <p>Paryż, od 1889 roku ma swoją &bdquo;Żelazną Damę&rdquo; &ndash; wieżę Eiffla. Śląsk też ma swoją wieżę Eiffla &ndash; gliwicką Radiostację, kt&oacute;ra g&oacute;ruje nad miastem od  roku 1935. </p>
			                <div class="page-list-item-button-container">
			                    <router-link class="arrow-link" to="/czy-wiecie-ze/gliwicka-radiostacja"  title="Gliwicka Radiostacja">Czytaj dalej</router-link>
			                </div>
			            </div>
			        </article>  
			    </div>
        </main>
    </div>
  </div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
export default {
  name: 'About',
  components: {
    Subpage
  }
}
</script>